<template>
  <default-layout>
    <event-navbar title="Timeline" />
    <div class="container-fluid">
      <user-timeline></user-timeline>
    </div>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import UserTimeline from '@/components/speaker/UserTimeline.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'UserTimelineView',
  components: {
    UserTimeline, EventNavbar, DefaultLayout
  },
}
</script>
